<template>
  <div class="container sv057">
    <BreadcrumbGroup :items="breadcrumbItems" />

    <HeadingOne>収入証明書について</HeadingOne>

    <p class="_mb-md-60 _mb-sm-40">
      貸金業法に基づき、収入証明書のご提出をお願いする場合がございます。<br />ご提出が必要なお客さまには、メールにてご案内させていただきます。
    </p>

    <section class="_mb-md-60 _mb-sm-40">
      <CardBox>
        <CardHeader>
          <h2 class="heading">収入証明書のご提出が必要な場合</h2>
        </CardHeader>
        <CardBody>
          <ListGroup>
            <ListItem
              >前回収入証明書をご提出いただいてから、2年以上経過している場合</ListItem
            >
          </ListGroup>
          <ListGroup>
            <ListItem
              >au PAY
              スマートローンのご利用限度額と他の貸金業者からのお借り入れ残高の合計が100万円を超える場合</ListItem
            >
          </ListGroup>
          <ListGroup>
            <ListItem
              >au PAY スマートローンのご利用限度額が50万円を超える場合</ListItem
            >
          </ListGroup>
        </CardBody>
      </CardBox>
    </section>

    <HeadingTwo>ご提出いただく収入証明書</HeadingTwo>

    <p class="_mb-md-50 _mb-sm-40">
      以下のいずれか1点のご提出をお願いします。各書類の有効期限にご注意ください。
    </p>

    <section class="_mb-md-60 _mb-sm-40">
      <TableBox>
        <TableBody>
          <TableRow>
            <TableHeader>源泉徴収票</TableHeader>
            <TableData>
              <ListGroup class="-normal">
                <ListItem class="-normal"
                  >源泉徴収票は、給与所得の源泉徴収票のみ受付が可能です。</ListItem
                >
                <ListItem class="-normal"
                  >最新（前年度分）のものをご提出ください。</ListItem
                >
                <ListItem class="-normal"
                  >ご提出日が1月の場合は前々年分、12月の場合は当年分の受付が可能です。</ListItem
                >
                <ListItem class="-normal"
                  >お名前、現在のお勤め先、支払金額が記載されているかをご確認ください。</ListItem
                >
                <ListItem class="-normal"
                  >個人番号（マイナンバー）が記載されている場合は、読み取れないよう隠して撮影してください。</ListItem
                >
                <ListItem class="-normal"
                  >手書きの場合は、発行元の押印が必要となります。</ListItem
                >
              </ListGroup>
            </TableData>
          </TableRow>
          <TableRow>
            <TableHeader>給与明細書</TableHeader>
            <TableData>
              <ListGroup class="-normal">
                <ListItem class="-normal"
                  >連続した直近2か月分をご提出ください。</ListItem
                >
                <ListItem class="-normal"
                  >賞与明細書がある場合は、直近1年分をあわせてご提出ください。</ListItem
                >
                <ListItem class="-normal"
                  >お名前、現在のお勤め先、支給総額が記載されているかをご確認ください。</ListItem
                >
                <ListItem class="-normal"
                  >手書きの場合は、発行元の押印が必要となります。</ListItem
                >
              </ListGroup>
            </TableData>
          </TableRow>
          <TableRow>
            <TableHeader>確定申告書</TableHeader>
            <TableData>
              <ListGroup class="-normal">
                <ListItem class="-normal"
                  >最新（前年分）のものをご提出ください。</ListItem
                >
                <ListItem class="-normal"
                  >ご提出日が1月から3月の場合は、前々年分の受付が可能です。</ListItem
                >
                <ListItem class="-normal"
                  >お名前、収入額、所得額、税務署/税理士事務所等の名称の記載、または、押印があるかをご確認ください。</ListItem
                >
                <ListItem class="-normal"
                  >電子申告の場合は、「受付日時」「受付番号」、または、「電子申告完了済」の文言が記載されているかをご確認ください。</ListItem
                >
                <ListItem class="-normal"
                  >個人番号（マイナンバー）が記載されている場合は、読み取れないよう隠して撮影してください。</ListItem
                >
              </ListGroup>
            </TableData>
          </TableRow>
          <TableRow>
            <TableHeader>納税通知書(住民税決定通知書)</TableHeader>
            <TableData>
              <ListGroup class="-normal">
                <ListItem class="-normal"
                  >納税通知書は、住民税決定通知書（市民税、県民税の特別徴収税額の決定・変更通知書など）のみ受付が可能です。</ListItem
                >
                <ListItem class="-normal"
                  >最新（前年分）のものをご提出ください。</ListItem
                >
                <ListItem class="-normal"
                  >ご提出日が1月から6月の場合は、前々年分の受付が可能です。</ListItem
                >
                <ListItem class="-normal"
                  >お名前、収入額、所得額、発行元の記載、および、押印があるかをご確認ください。</ListItem
                >
                <ListItem class="-normal"
                  >事業所得や不動産所得がある方など、給与所得以外の所得がある場合は、所得額の内訳が記載されているかをご確認ください。</ListItem
                >
              </ListGroup>
            </TableData>
          </TableRow>
          <TableRow>
            <TableHeader>所得（課税）証明書</TableHeader>
            <TableData>
              <ListGroup class="-normal">
                <ListItem class="-normal"
                  >最新（前年分）のものをご提出ください。</ListItem
                >
                <ListItem class="-normal"
                  >ご提出日が1月から6月の場合は、前々年分の受付が可能です。</ListItem
                >
                <ListItem class="-normal"
                  >お名前、収入額、所得額が記載されているかをご確認ください。</ListItem
                >
                <ListItem class="-normal"
                  >発行元が地方自治体の場合を除き、発行元の記載、および、押印が必要となります。</ListItem
                >
                <ListItem class="-normal"
                  >事業所得や不動産所得がある方など、給与所得以外の所得がある場合は、所得額の内訳が記載されているかをご確認ください。</ListItem
                >
              </ListGroup>
            </TableData>
          </TableRow>
        </TableBody>
      </TableBox>
    </section>

    <section class="_mb-md-120 _mb-sm-60">
      <CardBox class="_mb-10">
        <CardHeader>
          <BtnToggle collapse-target="accordion0" class="-plus">
            <h2 class="heading">年金受給者の方</h2>
          </BtnToggle>
        </CardHeader>
        <CollapseItem id="accordion0" accordion="accordion" :visible="true">
          <CardBody>
            <p>以下のいずれかの書類もあわせてご提出をお願いします。</p>

            <TableBox>
              <TableBody>
                <TableRow>
                  <TableHeader>年金証書</TableHeader>
                  <TableData>
                    <ListGroup class="-normal">
                      <ListItem class="-normal"
                        >年金証書は、裁定通知書欄（決定通知書欄）の記載があるもののみ受付が可能です。</ListItem
                      >
                      <ListItem class="-normal"
                        >最新のものをご提出ください。</ListItem
                      >
                      <ListItem class="-normal"
                        >お名前、年金の種類、年金額、支給開始年月、発行元の記載、および、押印があるかをご確認ください。</ListItem
                      >
                      <ListItem class="-normal"
                        >発行元は、公的機関、企業年金連合会、企業年金基金、「○○年金基金」と記載されているもののみ受付可能です。</ListItem
                      >
                      <ListItem class="-normal"
                        >基礎年金番号が記載されている場合は、読み取れないよう隠して撮影してください。</ListItem
                      >
                    </ListGroup>
                  </TableData>
                </TableRow>
              </TableBody>
            </TableBox>

            <TableBox>
              <TableBody>
                <TableRow>
                  <TableHeader>年金通知書</TableHeader>
                  <TableData>
                    <ListGroup class="-normal">
                      <ListItem class="-normal"
                        >最新（当年分）のものをご提出ください。</ListItem
                      >
                      <ListItem class="-normal"
                        >ご提出日が1月から6月の場合は、前年分の受付が可能です。</ListItem
                      >
                      <ListItem class="-normal"
                        >お名前、年金の種類、年金額、発行元の記載、および、押印があるかをご確認ください。</ListItem
                      >
                      <ListItem class="-normal"
                        >発行元は、公的機関、企業年金連合会、企業年金基金、「○○年金基金」と記載されているもののみ受付可能です。</ListItem
                      >
                      <ListItem class="-normal"
                        >基礎年金番号が記載されている場合は、読み取れないよう隠して撮影してください。</ListItem
                      >
                    </ListGroup>
                  </TableData>
                </TableRow>
              </TableBody>
            </TableBox>
          </CardBody>
        </CollapseItem>
      </CardBox>

      <ListGroup class="-note">
        <ListItem class="-note"
          >お名前・住所・生年月日がお申し込みいただいた内容と同じであることをご確認のうえご提出してください。</ListItem
        >
        <ListItem class="-note"
          >書類に個人番号（マイナンバー）、基礎年金番号等が記載されている場合は、読み取れないよう紙などで隠して撮影してください。</ListItem
        >
      </ListGroup>
    </section>

    <section class="_mb-md-120 _mb-sm-60">
      <HeadingTwo>撮影時のポイント</HeadingTwo>
      <div class="point-box _mb-md-30">
        <div class="point-img _mb-sm-30 _pr-md-20">
          <p class="txt01 _mb-md-30">
            <img
              src="@/assets/images/icons/circle-orange.svg"
              class="img-fluid _mr-md-20"
              alt=""
            />よい例
          </p>
          <img
            src="@/assets/images/sv/sv057/img01.jpg"
            class="img-fluid"
            alt=""
          />
          <ListGroup class="-normal _mt-15">
            <ListItem class="-normal">文字がはっきり読める</ListItem>
            <ListItem class="-normal">書類全体が写っている</ListItem>
          </ListGroup>
        </div>
        <div class="point-img _pl-md-20">
          <p class="txt01 _mb-md-30">
            <img
              src="@/assets/images/icons/close-gray.svg"
              class="img-fluid _mr-md-20"
              alt=""
            />悪い例
          </p>
          <img
            src="@/assets/images/sv/sv057/img02.jpg"
            class="img-fluid"
            alt=""
          />
          <ListGroup class="-normal _mt-15">
            <ListItem class="-normal">画像がぼやけている</ListItem>
            <ListItem class="-normal">写真が切れている</ListItem>
          </ListGroup>
        </div>
      </div>
      <ListGroup class="-note">
        <ListItem class="-note"
          >送付された画像に不備がある場合、当社よりお電話を差しあげることがございます。</ListItem
        >
      </ListGroup>
    </section>

    <CvBox class="_mb-md-120 _mb-sm-60" />

    <ContactBox class="_mb-md-120 _mb-sm-60" />
  </div>
  <!-- container -->
</template>

<script>
import HeadingOne from "@/components/heading/HeadingOne";
import HeadingTwo from "@/components/heading/HeadingTwo";
import BtnToggle from "@/components/button/BtnToggle";
import CardBox from "@/components/card/CardBox";
import CardHeader from "@/components/card/CardHeader";
import CardBody from "@/components/card/CardBody";
import CollapseItem from "@/components/collapse/CollapseItem";
import CvBox from "@/components/box/CvBox";
import ContactBox from "@/components/box/ContactBox";
import TableBox from "@/components/tables/TableBox";
import TableBody from "@/components/tables/TableBody";
import TableRow from "@/components/tables/TableRow";
import TableHeader from "@/components/tables/TableHeader";
import TableData from "@/components/tables/TableData";
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";
import { setMeta } from "@/utils/Meta";

export default {
  name: "Sv057",
  components: {
    ListItem,
    ListGroup,
    TableData,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    ContactBox,
    CvBox,
    CollapseItem,
    CardBody,
    CardHeader,
    CardBox,
    BtnToggle,
    HeadingOne,
    HeadingTwo,
    BreadcrumbGroup,
  },
  setup() {
    setMeta({
      title: "収入証明書について｜新規お申込方法",
      description:
        "収入証明書類のご提出が必要な場合と、必要な書類について分かりやすくご説明します。au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,収入証明書",
    });
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "root",
        },
        {
          text: "お申し込み条件・お手続きの流れ",
          routerName: "sv045",
        },
        {
          text: "収入証明書について",
          active: true,
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";

.sv057 {
  .border-box {
    border: 1px solid $secondary;
    border-radius: 10px;
    padding-top: 20px;
    padding-bottom: 20px;
    @include mq-down(md) {
      padding-left: 20px;
      padding-right: 20px;
    }
    @include mq-up(md) {
      padding-top: 30px;
      padding-bottom: 30px;
      text-align: center;
    }
    > .txt01 {
      color: $danger;
      font-weight: bold;
      font-size: 16px;
      line-height: 24px;
      @include mq-up(md) {
        font-size: 20px;
      }
      img {
        vertical-align: sub;
      }
      > .exclamation {
        width: 18px;
        @include mq-up(md) {
          width: 25px;
        }
      }
    }
  }
}

.document-wrap01 {
  display: flex;
  @include mq-down(md) {
    flex-wrap: wrap;
  }
  @include mq-up(md) {
    justify-content: center;
  }
  > .document-box {
    width: 50%;
    text-align: center;
    font-weight: bold;
    @include mq-up(md) {
      max-width: 280px;
      width: 100%;
    }
  }
}

.document-wrap02 {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  @include mq-down(md) {
    flex-wrap: wrap;
  }
  > .document-box {
    width: 50%;
    text-align: center;
    font-weight: bold;
    @include mq-up(md) {
      max-width: 280px;
      width: 100%;
    }
  }
  > .plus-box {
    width: 40px;
    @include mq-down(md) {
      width: 30px;
    }
    @include mq-up(md) {
      margin-top: 125px;
    }
  }
  > .document-bg {
    background-color: $success;
    border-radius: 10px;
    padding: 25px;
    @include mq-down(md) {
      padding-bottom: 20px;
    }
    @include mq-up(md) {
      padding: 30px 25px;
    }
    > .txt01 {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 15px;
      @include mq-up(md) {
        margin-bottom: 25px;
        font-size: 20px;
      }
    }
    > .list-group {
      > .list-item {
        list-style-type: decimal !important;
      }
    }
  }
}

.point-box {
  display: flex;
  flex-wrap: wrap;
  > .point-img {
    width: 100%;
    @include mq-up(md) {
      width: 50%;
    }
    > .txt01 {
      width: 100%;
      display: flex;
      align-items: center;
      font-weight: bold;
      img {
        width: 20px;
        @include mq-up(md) {
          width: 30px;
        }
      }
    }
  }
}

.card-box {
  > .collapse {
    > .card-body {
      > .list-group {
        > .list-item {
          list-style-type: decimal !important;
        }
      }
    }
  }
}

.point-box {
  > .point-img {
    > .list-group {
      > .list-item {
        list-style-type: disc;
      }
    }
  }
}
</style>
